import styled from 'styled-components';

export const MarginBottom = styled.div`
	margin-bottom: 40px;
`;
